/**
 * Společná inicializace aplikace, např. nastavení polyfill atp.
 */

// Polyfill na ES6 od Babel
require("babel-polyfill");

//
// Promise plyfill - IE9
const es6promise = require('es6-promise');
es6promise.polyfill();

// Ostatní
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}
